import { InboundDbListSegStrategy } from 'customer-data-filters-ui/public/strategies';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StyledSegmentationFilters from 'automation-ui-enrollment/components/common/StyledSegmentationFilters';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ON_START_KEYS = ['EDITED_FILTERS'];
const ON_DONE_KEYS = ['CONFIRMED_CHANGES', 'DISCARDED_CHANGES', 'CANCELED_CHANGES'];

// The SegementationFilters component requires that the top-level filterBranch has a type of "OR". We have several workflow source apps that created
// enrollment list branches with top-level ANDs instead, which is functionally the same in terms of evaluation but not a supported rendering format on the UI.
// https://issues.hubspotcentral.com/browse/WORKFLOWS-16122
const populateTopLevelOrBranchIfMissing = filterBranch => {
  if (filterBranch && filterBranch.filterBranchType === 'AND') {
    return {
      filterBranchType: 'OR',
      filterBranchOperator: 'OR',
      filterBranches: [filterBranch],
      filters: []
    };
  }
  return filterBranch;
};
const ListSegmentationFilters = ({
  objectTypeId,
  readOnly,
  value: unsanitizedValue,
  headerNode,
  isEditButtonDisabled,
  editButtonDisabledTooltipMessage,
  showDoneButton,
  hideEditCancelDiscardButton,
  openInEditMode,
  isEmbedded = false,
  useCustomEditorContainer = true,
  showTestButton = true,
  layout = 'embedded',
  onChange = () => {},
  onFilterInfoChange = () => {},
  onStartEditingFilters = () => {},
  onDoneEditingFilters = () => {},
  onFiltersEditorPanelOpenChange = () => {},
  WrapperComponent = Fragment,
  uiMessagesOverrides = {},
  onClosePanel
}) => {
  const value = populateTopLevelOrBranchIfMissing(unsanitizedValue);
  const handleChange = (filterBranch, filterInfo) => {
    if (filterBranch) {
      onChange(filterBranch);
    }
    onFilterInfoChange(filterInfo);
  };
  const handleEditModeChange = editMode => {
    if (ON_START_KEYS.includes(editMode)) {
      onStartEditingFilters();
    } else if (ON_DONE_KEYS.includes(editMode)) {
      onDoneEditingFilters();
    }
  };
  const testableStrategy = InboundDbListSegStrategy.configure({
    isTestFiltersEnabled: showTestButton && !readOnly && !isFilterEmpty(value),
    // readOnly keeps 'Test object' button from appearing in filter viewer
    isSameObjectAssociationFilteringEnabled: true
  });
  const editButtonsState = {
    disabled: isEditButtonDisabled,
    tooltipTitle: editButtonDisabledTooltipMessage
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [headerNode, !value && readOnly ? /*#__PURE__*/_jsx(WrapperComponent, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.noFilterCriteria"
      })
    }) : /*#__PURE__*/_jsx(StyledSegmentationFilters, {
      baseFilterFamily: objectTypeId,
      editButtonsState: editButtonsState
      // TODO - remove this prop once embed is better supported: https://issues.hubspotcentral.com/browse/AUTOPG-2179
      ,
      uiMessages: Object.assign({
        filtersHeaderLabel: readOnly ? null : /*#__PURE__*/_jsx(_Fragment, {}),
        addFilterButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.addTrigger"
        }),
        addFilterGroupButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.addTriggerGroup"
        }),
        editorAddFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.addTrigger"
        }),
        editFiltersButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.editTriggers"
        }),
        editorEditFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.editTrigger"
        }),
        viewerEmptyFilters: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.noTriggers"
        }),
        newFilterPlaceholderMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.triggerAddPlaceholder"
        })
      }, uiMessagesOverrides),
      isEmbedded: isEmbedded,
      isReadOnly: readOnly,
      onChange: handleChange,
      onEditModeChange: handleEditModeChange,
      onFiltersEditorPanelOpenChange: onFiltersEditorPanelOpenChange,
      showDoneButton: showDoneButton,
      hideEditCancelDiscardButton: hideEditCancelDiscardButton,
      value: value,
      strategy: testableStrategy,
      layout: layout,
      openInEditMode: openInEditMode,
      skipEmptyFiltersState: openInEditMode,
      useCustomEditorContainer: useCustomEditorContainer,
      WrapperComponent: WrapperComponent,
      onClosePanel: onClosePanel
    })]
  });
};
export default ListSegmentationFilters;